import { END_POINT } from "constants/apiConstant";
import { apiPost } from "../utils/apiUtils";

const {
  ELEMENT14_AUTH_TOKEN,
  ELEMENT14_CART_CREATE,
  ELEMENT14_SHIPPING_ADDRESS,
  ELEMENT14_SHIPPING_ADDRESS_CONFIRM,
  ELEMENT14_SHIPPING_METHODS,
  ELEMENT14_SHIPPING_METHOD_CONFIRM,
  ELEMENT14_ORDER_SUBMIT,
} = END_POINT;

export const element14AuthToken = async () => {
  return await apiPost(ELEMENT14_AUTH_TOKEN, {});
};

export const element14AddToCart = async ({ orderItem, element_14_auth_token, orderId }) => {
  return await apiPost(ELEMENT14_CART_CREATE, {
    orderItem,
    element_14_auth_token,
    orderId,
  });
};

export const element14GetShippingAddress = async ({ element_14_auth_token }) => {
  return await apiPost(ELEMENT14_SHIPPING_ADDRESS, { element_14_auth_token });
};

export const element14ConfirmShippingAddress = async ({
  addressId,
  addressDetails,
  element_14_auth_token,
  orderId,
}) => {
  return await apiPost(ELEMENT14_SHIPPING_ADDRESS_CONFIRM, {
    addressId,
    addressDetails,
    element_14_auth_token,
    orderId,
  });
};

export const element14GetShippingMethods = async ({ element_14_auth_token }) => {
  return await apiPost(ELEMENT14_SHIPPING_METHODS, { element_14_auth_token });
};

export const element14ConfirmShippingMethod = async ({
  shippingMethodID,
  shippingMethod,
  element_14_auth_token,
  orderId,
}) => {
  return await apiPost(ELEMENT14_SHIPPING_METHOD_CONFIRM, {
    shippingMethodID,
    shippingMethod,
    element_14_auth_token,
    orderId,
  });
};

export const element14OrderSubmit = async ({ element_14_auth_token, orderId }) => {
  return await apiPost(ELEMENT14_ORDER_SUBMIT, {
    element_14_auth_token,
    orderId,
  });
};
